module.exports = __webpack_public_path__ + "static/media/copy-shadow.fa07fdfc.svg";